module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-box-filter ls-no-margin-bottom"
  }, [_c('form', {
    staticClass: "ls-form ls-form-horizontal row"
  }, [_c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "ls-label col-lg-4 col-xlg-4 col-md-4 col-xs-12"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('orders.attributes.customer')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_customer_name),
      expression: "search_customer_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('invoices.attributes.customer')
    },
    domProps: {
      "value": (_vm.search_customer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_customer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-12"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('orders.filter.contract_code')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_contract_code),
      expression: "search_contract_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Ex.: Abc123"
    },
    domProps: {
      "value": (_vm.search_contract_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_contract_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-lg-2 col-xlg-2 col-md-2 col-xs-12"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('orders.filter.invoice_id')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_invoice_id),
      expression: "search_invoice_id"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "1"
    },
    domProps: {
      "value": (_vm.search_invoice_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_invoice_id = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-lg-3 col-md-3 col-xlg-2 col-xs-12"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.status')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-custom-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_status),
      expression: "search_status"
    }],
    staticClass: "ls-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('application.filter.all')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.status.reversed')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.status.paid')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.status.not_paid')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.status.pending')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-action"
  }, [_c('button', {
    staticClass: "ls-btn-danger ls-no-margin-bottom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearFilters,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.clearFilters($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('application.filter.clear_filters')))])]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn ls-no-margin-bottom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchOrders
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('application.filter.filter')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5717c04e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/orders/components/Filter.vue
// module id = 782
// module chunks = 1